export default __webpack_public_path__ + "static/media/whoop-circle-black.b7043263.svg";